import { render, staticRenderFns } from "./dealer-list.vue?vue&type=template&id=57743fb8&scoped=true"
import script from "./dealer-list.vue?vue&type=script&lang=js"
export * from "./dealer-list.vue?vue&type=script&lang=js"
import style0 from "./dealer-list.vue?vue&type=style&index=0&id=57743fb8&prod&scoped=true&lang=scss"
import style1 from "./dealer-list.vue?vue&type=style&index=1&id=57743fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57743fb8",
  null
  
)

export default component.exports